import { ComboField } from '@components/Fields/ComboField';
import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { IComboCaixa } from '@model/Caixa';
import { ICaixaFilter } from '@services/CaixaService';
import React from 'react';

export type CaixaFilterProps = {
    filter: IFilter<ICaixaFilter>
    isLoading: boolean
    caixaCombo: IComboCaixa
}

export function CaixaFilter ({ filter, isLoading, caixaCombo }: CaixaFilterProps) {
    const clienteNomeInputRef = React.createRef<HTMLInputElement>();
    
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
        clienteNomeInputRef.current?.focus();
    }, [filter, clienteNomeInputRef]);

    React.useEffect(() => {
        clienteNomeInputRef.current?.focus();
    }, [clienteNomeInputRef])

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={3}>
                    <ComboField
                        field={filter.fields.caixaId}
                        label="Proprietário"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        updateFieldStateOnChange
                        disabled={isLoading}
                        required
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        {
                            caixaCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <CompetenciaField
                        field={filter.fields.competencia}
                        label="Competência"
                        onEnter={filter.handleFilterRequest}
                        updateFieldStateOnChange
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>
           </HorizontalGrid>
        </FixedFilterPanel>
    )
}